<template>
  <div>
    <ul class="add">
      <li>
        <h6 v-if="items && items.length">
          {{ "total_questions" | setText("всего вопросов") }}:
          {{ items.length }}
        </h6>
        <button @click="add" class="btn btn-sm btn-info">
          <span class="ti-plus"></span>
          {{ "add_question" | setText("Добавить вопрос") }}
        </button>
      </li>
    </ul>
    <div>
      <div>
        <ul id="messageDisplay" class="question ord-list" ref="messageDisplay">
          <li v-for="(item, key) in items" :key="key">
            <div>
              <h3>ВОПРОС: {{ key + 1 }}</h3>
              <radio-list
                :readonly="true"
                v-model="item.type"
                :items="types"
                :name="`name_${item.id}`"
              />
              <div class="row ai-center m-y-3">
                <div class="col-md-8 col-12">
                  <fg-input
                    class="m-b-0"
                    type="text"
                    :label="`Заголовок`"
                    v-model="item.title"
                  ></fg-input>
                </div>
                <div class="col-md-4 col-12">
                  <fg-input
                  class="m-b-0"
                  type="number"
                  name="complexity"
                  :label="`Стоимость вопроса`"
                  v-model="item.complexity"
                ></fg-input>
                  <!-- <div class="nova-control-wrapper">
                    <input type="number" name="complexity" class="form-control" v-model="item.complexity">
                    <label class="nova-label-control">
                      Стоимость вопроса
                    </label>
                  </div> -->
                </div>
              </div>
              <!-- <label for="">{{
                  "title" | setText("Заголовок")
              }}</label>
              <RichEditor
                v-model="item.title"
              /> -->

              <audio-upload-base
                :name="`item_${item['id']}`"
                v-model="item.audio_document"
              />

              <label for="">{{
                "description_question" | setText("Описание (вопрос)")
              }}</label>
              <RichEditor
                v-model="item.description"
              />
            </div>
            <div class="answers" v-if="item.type === 'test'">
              <h6>
                {{
                  "add_variant_question" | setText("Добавить вариант ответа")
                }}
              </h6>
              <div class="group">
                <fg-input v-model="newAnswer.title" type="text"></fg-input>
                <checkbox v-model="newAnswer.is_true" color="#ffc107">{{
                  "right" | setText("Правильный")
                }}</checkbox>
                <button
                  @click="addVariant(key)"
                  class="btn btn-sm btn-info mt-2"
                >
                  {{ "add_answer" | setText("Добавить ответ") }}
                </button>
              </div>
              <h6>{{ "question_variants" | setText("Варианты ответов") }}</h6>
              <draggable
                :tag="'ul'"
                v-model="item.answers"
                handle=".handle"
                class="row"
              >
                <li
                  v-for="answer in item.answers"
                  :key="answer.id"
                  class="handle col-12 col-md-6"
                >
                  <div class="group">
                    <fg-input type="text" v-model="answer.title"></fg-input>
                    <audio-upload-base
                      :name="`answer_${answer['id']}`"
                      v-model="answer.audio_document"
                    />
                    <img-upload-base64
                      :name="answer['id']"
                      v-model="answer.img"
                    />
                    <checkbox v-model="answer.is_true" color="#ffc107"
                      >{{ "right" | setText("Правильный") }}
                    </checkbox>
                    <checkbox v-model="answer.is_delete" color="#ffc107"
                      >{{ "delete" | setText("Удалить") }}
                    </checkbox>
                  </div>
                </li>
              </draggable>
            </div>
            <div class="answers" v-if="item.type === 'order'">
              <h6>
                {{
                  "add_variant_question" | setText("Добавить вариант ответа")
                }}
              </h6>
              <div class="group">
                <button
                  @click="addVariant(key)"
                  class="btn btn-sm btn-info mt-2"
                >
                  {{ "add_answer" | setText("Добавить ответ") }}
                </button>
              </div>
              <h6>{{ "question_variants" | setText("Варианты ответов") }}</h6>
              <draggable
                :tag="'ul'"
                v-model="item.answers"
                handle=".handle"
                class="row"
              >
                <li
                  v-for="answer in item.answers"
                  :key="answer.id"
                  class="handle col-12 col-md-6"
                >
                  <div class="group">
                    <fg-input type="text" v-model="answer.title"></fg-input>
                    <audio-upload-base
                      :name="`answer_${answer['id']}`"
                      v-model="answer.audio_document"
                    />
                    <img-upload-base64
                      :name="answer['id']"
                      v-model="answer.img"
                    />
                    <checkbox v-model="answer.is_delete" color="#ffc107"
                      >{{ "delete" | setText("Удалить") }}
                    </checkbox>
                  </div>
                </li>
              </draggable>
            </div>
            <div class="answers" v-if="item.type === 'glue'">
              <h6>
                {{
                  "add_variant_question" | setText("Добавить вариант ответа")
                }}
              </h6>
              <div class="group">
                <!-- <fg-input v-model="newAnswer.title" type="text"></fg-input> -->
                <!-- <checkbox v-model="newAnswer.is_true" color="#ffc107">{{ 'right' | setText('Правильный') }}</checkbox> -->
                <button
                  @click="addVariant(key)"
                  class="btn btn-sm btn-info mt-2"
                >
                  {{ "add_answer" | setText("Добавить ответ") }}
                </button>
              </div>
              <h6>{{ "question_variants" | setText("Варианты ответов") }}</h6>
              <draggable
                :tag="'ul'"
                v-model="item.answers"
                handle=".handle"
                class="row"
              >
                <li
                  v-for="answer in item.answers"
                  :key="answer.id"
                  class="handle col-12 col-md-6"
                >
                  <div class="group">
                    <fg-input type="text" v-model="answer.title"></fg-input>
                    <audio-upload-base
                      :name="`answer_${answer['id']}`"
                      v-model="answer.audio_document"
                    />
                    <img-upload-base64
                      :name="answer['id']"
                      v-model="answer.img"
                      :title="`Первое фото`"
                    />
                    <label>Группировать:</label>
                    <group-symbol
                      :answer="answer"
                      v-model="answer['group_symbol']"
                    />

                    <checkbox v-model="answer.is_delete" color="#ffc107"
                      >{{ "delete" | setText("Удалить") }}
                    </checkbox>
                  </div>
                </li>
              </draggable>
            </div>
            <div class="answers" v-if="item.type === 'dropdown'">
              <DropDownType
                :item="item"
                :itemKey="key"
                @dropdown-variant-added="dropDownVariantAdded"
                @dropdown-variant-answer-added="dropdownVariantAnswerAdded"
                @dropdown-variant-answer-removed="dropdownAnswerRemoved"
                @dropdown-description-changed="dropdownDescriptionChanged"
              />
            </div>

            <div class="answers" v-if="item.type === 'miss-word'">
              <miss-word v-model="item.metadata.variants" />
            </div>

            <div class="answers" v-if="item.type === 'drag-and-drop'">
              <drag-and-drop v-model="item.metadata.variants" />
            </div>

            <div class="control">
              <button
                @click="updateItem(key)"
                class="btn btn-sm btn-success mr-2"
              >
                <span class="ti-save"></span>
                {{ "save" | setText("Сохранить") }}
              </button>
              <button
                @click="deleteItem(item, key)"
                class="btn btn-sm btn-danger"
              >
                <span class="ti-trash"></span>
              </button>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <modal name="add" height="auto" width="800" class="mw-100">
      <div class="ord-parent">
        <div class="ord-list">
          <radio-list
            v-model="newItem.type"
            :items="types"
            :name="`name_new`"
          />
        </div>
        <div class="flex ai-end z-index-1 p-relative">
          <div class="m-b-0 ord-input-header">
            <fg-input
              type="text"
              :label="`Заголовок`"
              v-model="newItem.title"
            ></fg-input>
          </div>
          <div class="ord-input-price">
            <label for="">Стоимость вопроса</label>
            <input type="number" name="complexity" class="form-control" v-model="newItem.complexity">
          </div>
        </div>
        <div class="ord">
          <div class="m-y-2">
            <label for="">{{
              "description_question" | setText("Описание (вопрос)")
            }}</label>
            <RichEditor
              v-model="newItem.description"
              :options="$store.state.editorOption"
            />
          </div>
          <div class="answers" v-if="newItem.type === 'test'">
            <h6>
              {{ "add_answer_variant" | setText("Добавить вариант ответа") }}
            </h6>

            <div class="group">
              <fg-input v-model="newAnswer.title" type="text"></fg-input>
              <checkbox v-model="newAnswer.is_true" color="#ffc107">{{
                "right" | setText("Правильный")
              }}</checkbox>
              <button @click="addVariantNew" class="btn btn-sm btn-info mt-2">
                {{ "add_answer" | setText("Добавить ответ") }}
              </button>
            </div>

            <h6 v-if="newItem.answers.length">
              {{ "question_variants" | setText("Варианты ответов") }}
            </h6>
            <draggable
              :tag="'ul'"
              v-model="newItem.answers"
              handle=".handle-new"
              class="row"
            >
              <li
                v-for="(answer, answerKey) in newItem.answers"
                :key="answer.id"
                class="col-12 col-md-6 handle-new"
              >
                <div class="group">
                  <fg-input type="text" v-model="answer.title"></fg-input>

                  <audio-upload-base
                    :name="`answer_${answer['id']}`"
                    v-model="answer.audio_document"
                  />

                  <img-upload-base64
                    :name="answer['id']"
                    v-model="answer.img"
                    :title="`Первое фото`"
                  />

                  <checkbox v-model="answer.is_true" color="#ffc107">{{
                    "right" | setText("Правильный")
                  }}</checkbox>
                  <checkbox v-model="answer.is_delete" color="#ffc107">{{
                    "delete" | setText("Удалить")
                  }}</checkbox>
                </div>
              </li>
            </draggable>
          </div>

          <div class="answers" v-else-if="newItem.type === 'glue'">
            <h6>
              {{ "add_answer_variant" | setText("Добавить вариант ответа") }}
            </h6>
            <div class="group">
              <button @click="addVariantNew" class="btn btn-sm btn-info mt-2">
                {{ "add_answer" | setText("Добавить ответ") }}
              </button>
            </div>

            <h6 v-if="newItem.answers.length">
              {{ "question_variants" | setText("Варианты ответов") }}
            </h6>

            <draggable
              :tag="'ul'"
              v-model="newItem.answers"
              handle=".handle-new"
              class="row"
            >
              <li
                v-for="(answer, answerKey2) in newItem.answers"
                :key="answer.id"
                class="col-12 col-md-6 handle-new"
              >
                <div class="group">
                  <fg-input type="text" v-model="answer.title"></fg-input>

                  <audio-upload-base
                    :name="`answer_${answer['id']}`"
                    v-model="answer.audio_document"
                  />

                  <img-upload-base64
                    :name="answer['id']"
                    v-model="answer.img"
                    :title="`Первое фото`"
                  />

                  <label>Группировать:</label>

                  <group-symbol
                    :answer="answer"
                    v-model="answer['group_symbol']"
                  />
                  <!-- <img-upload-base64 v-model="answer.img_second" :title="`Второе фото`" /> -->
                  <checkbox v-model="answer.is_delete" color="#ffc107">{{
                    "delete" | setText("Удалить")
                  }}</checkbox>
                </div>
              </li>
            </draggable>
          </div>

          <div class="answers" v-else-if="newItem.type === 'order'">
            <h6>
              {{ "add_answer_variant" | setText("Добавить вариант ответа") }}
            </h6>
            <div class="group">
              <button @click="addVariantNew" class="btn btn-sm btn-info mt-2">
                {{ "add_answer" | setText("Добавить ответ") }}
              </button>
            </div>
            <h6 v-if="newItem.answers.length">
              {{ "question_variants" | setText("Варианты ответов") }}
            </h6>
            <draggable
              :tag="'ul'"
              v-model="newItem.answers"
              handle=".handle-new"
              class="row"
            >
              <li
                v-for="(answer, answerKey3) in newItem.answers"
                :key="answer.id"
                class="col-12 col-md-6 handle-new"
              >
                <div class="group">
                  <fg-input type="text" v-model="answer.title"></fg-input>

                  <audio-upload-base
                    :name="`answer_${answer['id']}`"
                    v-model="answer.audio_document"
                  />
                  <img-upload-base64
                    :name="answer['id']"
                    v-model="answer.img"
                    :title="`Первое фото`"
                  />
                  <checkbox v-model="answer.is_delete" color="#ffc107">{{
                    "delete" | setText("Удалить")
                  }}</checkbox>
                </div>
              </li>
            </draggable>
          </div>

          <div class="answers" v-if="newItem.type === 'dropdown'">
            <DropDownType
              :item="newItem"
              :itemKey="null"
              @dropdown-variant-added="dropDownVariantAdded"
              @dropdown-variant-answer-added="dropdownVariantAnswerAdded"
              @dropdown-variant-answer-removed="dropdownAnswerRemoved"
              @dropdown-description-changed="dropdownDescriptionChanged"
            />
          </div>
          <!-- <div class="answers" v-if="newItem.type === 'miss-word'">
            <MissWord
              :item="newItem"
              :itemKey="null"
              @dropdown-variant-added="dropDownVariantAdded"
              @dropdown-variant-answer-added="dropdownVariantAnswerAdded"
              @dropdown-variant-answer-removed="dropdownAnswerRemoved"
              @dropdown-description-changed="dropdownDescriptionChanged"
            />
          </div> -->

          <div class="control">
            <button @click="createItem" class="btn btn-sm btn-success mt-2 mr-2">
              <span class="ti-save"></span> {{ "save" | setText("Сохранить") }}
            </button>
            <button
              @click="$modal.hide('add')"
              class="btn btn-sm btn-warning mt-2"
            >
              Отмена
            </button>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import { errorNotify } from "@/plugins/functions";

import RichEditor from "@/components/Editor/RichTextEditor.vue";
import draggable from "vuedraggable";
import GroupSymbol from "./GroupSymbol";
import DropDownType from "./Questions/Dropdown.vue";
import MissWord from "./Questions/MissWord.vue";
import DragAndDrop from "./Questions/DragAndDrop.vue";
export default {
  components: {
    RichEditor,
    draggable,
    GroupSymbol,
    DropDownType,
    MissWord,
    DragAndDrop,
  },
  data: () => ({
    newAnswer: {
      title: "",
      is_true: false,
      is_delete: false,
      group_symbol: null,
      id: new Date().getTime(),
    },
    newItem: {
      title: "",
      complexity: 1,
      type: "test",
      answers: [],
      audio_document: null,
      metadata: {
        variants: [],
      },
    },
    types: [
      { title: "Тест", id: "test" },
      { title: "Загрузка документа", id: "upload" },
      { title: "Текстовый ответ", id: "text" },
      { title: "Упорядоченность", id: "order" },
      { title: "Склеить", id: "glue" },
      { title: "Выпадающий список", id: "dropdown" },
      { title: "Пропущенное слово", id: "miss-word" },
      { title: "Пропущенное слово с вариантами", id: "drag-and-drop" },
    ],
    addType: null,
    cardLink: "",
    items: [],
  }),
  props: ["id"],
  async created() {
    this.cardLink = `works/${this.id}/questions`;
    this.$loading(true);
    this.items = await this.$http
      .get(this.cardLink)
      .then((response) => {
        return response.data.data;
      })
      .catch((error) => {
        errorNotify(error, this.$notify);
      })
      .finally(() => {
        this.$loading(false);
      });
  },
  methods: {
    addVariant(key) {
      this.items[key].answers.push({ ...this.newAnswer });
      this.newAnswer = {
        title: "",
        is_true: false,
        is_delete: false,
        group_symbol: null,
        id: new Date().getTime(),
      };
    },
    addVariantNew() {
      this.newItem.answers.push({ ...this.newAnswer });
      this.newAnswer = {
        id: new Date().getTime(),
        title: "",
        is_true: false,
        is_delete: false,
        group_symbol: null,
      };
    },
    add(addType) {
      this.addType = addType;
      this.$modal.show("add");
    },
    scrollBottom(delay) {
      setTimeout(() => {
        let element = this.$refs.messageDisplay;

        element.scrollIntoView({ behavior: "smooth", block: "end" });
      }, delay);
    },
    async createItem() {
      this.$loading(true);

      let newItem = await this.$http
        .post(this.cardLink, this.newItem)
        .then((response) => {
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });

      if (newItem) {
        this.$modal.hide("add");
        this.items.push(newItem);
        this.newItem = {
          title: "",
          type: "test",
          answers: [],
          audio_document: null,
          metadata: {
            variants: [],
          },
        };

        this.scrollBottom(10);
      }
    },
    async updateItem(key) {
      this.$loading(true);
      await this.$http
        .put(`${this.cardLink}/${this.items[key].id}`, this.items[key])
        .then((response) => {
          this.items[key] = response.data.data;
          return response.data.data;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    async deleteItem(item, key) {
      this.$loading(true);
      let newItem = await this.$http
        .delete(`${this.cardLink}/${item.id}`)
        .then((response) => {
          this.items.splice(key, 1);
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.$loading(false);
        });
    },
    dropDownVariantAdded(data) {
      const { itemKey } = data;

      const newVariant = {
        answers: data.answers,
        description: data.description,
      };

      if (this.items[itemKey]) {
        this.items[itemKey].metadata.variants.push(newVariant);
        return;
      }

      this.newItem.metadata.variants.push(newVariant);
    },
    dropdownVariantAnswerAdded(data) {
      const { itemKey, answerData, variantKey } = data;

      if (itemKey === null) {
        if (
          !Object.hasOwn(this.newItem.metadata.variants[variantKey], "answers")
        ) {
          this.$set(this.newItem.metadata.variants, variantKey, {
            answers: [],
          });
        }

        this.newItem.metadata.variants[variantKey].answers.push(answerData);

        return;
      }

      const item = this.items[itemKey];

      if (!Object.hasOwn(item.metadata.variants[variantKey], "answers")) {
        this.$set(this.items[itemKey].metadata.variants, variantKey, {
          answers: [],
        });
      }

      item.metadata.variants[variantKey].answers.push(answerData);
    },
    dropdownAnswerRemoved(data) {
      const { itemKey, variantKey, answerKey } = data;

      if (itemKey === null) {
        this.newItem.metadata.variants[variantKey].answers.splice(answerKey, 1);
        return;
      }

      this.items[itemKey].metadata.variants[variantKey].answers.splice(
        answerKey,
        1
      );
    },
    dropdownDescriptionChanged(data) {
      const { itemKey, variantKey, value } = data;

      if (itemKey === null) {
        this.newItem.metadata.variants[variantKey].description = value;
        return;
      }

      this.items[itemKey].metadata.variants[variantKey].description = value;
    },
  },
};
</script>
<style lang="scss">
.add {
  text-align: right;
  position: fixed;
  right: 0;
  top: 120px;
  z-index: 999;
  padding: 25px;
}
:root{
  --ck-border-radius: 12px;
}
.ord-input{
  &-header{
    width: 100%;
    background: white;
    margin-bottom: -20px !important;
    padding: 15px 15px 15px 15px;
    border-radius: 20px 20px 0 0;
  }
  &-price{
    position: relative;
    padding: 15px;
    min-width: 200px;
    background-color: #dedbe3;
    border-radius: 20px;
    input{
      border-color: #ccc;
    }
    &:before{
      content: "";
      display: block;
      position: absolute;
      left: 0;
      bottom: 0;
      background-color: white;
      z-index: -1;
      width: 50%;
      height: 50%;
    }
    *{
      position: relative;
      z-index: 1;
    }
  }
}
.ord-parent{
  background: #dedbe3;
  border-radius: 20px;
  padding: 0 15px 20px 15px;
  input[type=number]{
    background-color: white;
  }
  label{
    color: #363636;
  }
  .btn{
    border-radius: 8px;
    padding: 5px 15px;
  }
}
ul.status{
  &.disabled{
    li{
      margin-right: 0 !important;
    }
    label{
      display: none;
    }
    input:checked{
      &~label{
        display: block;
      }
    }
  }
}
.ord {
  border-radius: 20px;
  padding: 15px 15px 20px 15px;
  background-color: white;

  &-list{
    // background-color:;
    padding: 20px 5px 5px 5px;
    border-radius: 20px 20px 0 0;
    .radio-item{
      display: none;
    }
    ul.status{
      label{
        text-transform: none;
        font-size: 15px;
        font-weight: 400;
        line-height: 100%;
        background-color: white;
        padding: 7px 18px;
        border-radius: 8px;
        &:hover{
          cursor: pointer;
        }
      }
      input{
        display: none;
        &:checked{
          &~label{
            background-color: #3534a9;
            color: white;
          }
        }
      }
      li{
        margin-right: 8px;
        &>div{
          
        }
      }
    }
  }
}

ul.question {
  list-style: none;
  margin: 70px 0 0;
  padding: 0;
  .group {
    background: #fff;
    padding: 10px 10px;  
  }  
  input[type=number]{
    background-color: white;
  }
  & > li {
    position: relative;
    overflow: hidden;
    background: #f2f2f2;
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 15px;

    & .control {
      margin-top: 20px;
    }
  }
}

.ql-editor {
  background: #fff;
  border-radius: 20px;
}

.answers {
  margin-top: 20px;
  & h6 {
    margin-bottom: 5px;
  }
}
.handle-new{
  .group{
    background: #f7f7f7;
    padding: 12px 15px;
  }
}
.group {
  // background: #fff;
  // padding: 10px 10px;
  padding: 0;
  border-radius: 10px;
  margin-bottom: 30px;
  & > div {
    margin: 5px 0;
  }
}
</style>
